export default __webpack_public_path__ + "static/media/130.5eb14124.svg";